import { AdminBaseService } from "./admin-base.service";
import { PaginatedResult } from "./base.service";
import { FilterDto } from "@/hooks/filterUtils";
import {
  CreateTypeAheadDto,
  TypeAhead,
  UpdateTypeAheadDto,
} from "@/types/typeAhead";

class TypeAheadAdminService extends AdminBaseService {
  constructor() {
    super("/type-ahead-admin");
  }
  async getAll(dto: FilterDto): Promise<PaginatedResult<TypeAhead>> {
    return await this.post<PaginatedResult<TypeAhead>>("/getAll", dto);
  }

  async add(data: CreateTypeAheadDto): Promise<TypeAhead> {
    return await this.post<TypeAhead>("", data);
  }

  async update(data: UpdateTypeAheadDto): Promise<TypeAhead> {
    return await this.put<TypeAhead>("", data);
  }

  async remove(category: string): Promise<TypeAhead> {
    return await this.delete<TypeAhead>(`/${category}`);
  }
}

export const typeAheadAdminService = new TypeAheadAdminService();
